// podtemat1_prostokaty_kwadraty_types/SquareDiagonalFromSideTask.js
import React from "react";
import { InlineMath, BlockMath } from "react-katex";
import RootFractionInput, {
  parseRootFractionInput as parseRoot,
  formatLatexPreview,
} from "../../../../components/inputs/RootFractionInput";

const DEC_TOL = 0.01;
const pick = (arr) => arr[Math.floor(Math.random() * arr.length)];

export function generateTask() {
  const A = Array.from({ length: 18 }, (_, i) => i + 3); // 3..20
  const a = pick(A);
  const dValue = a * Math.SQRT2;
  const dLatex = `${a}\\sqrt{2}`;
  return { type: "SquareDiagonalFromSideTask", data: { a, dValue, dLatex } };
}

export function renderTask({ data }) {
  const { a } = data;
  return (
    <div style={{ marginTop: 8, marginBottom: 8 }}>
      Dany jest kwadrat o boku <InlineMath math={`a=${a}`} />.
      Oblicz długość jego przekątnej <InlineMath math={'d'} />.
    </div>
  );
}

export function renderInput(_task, userAnswer, onChange, disabled) {
  const raw = typeof userAnswer === "string" ? userAnswer : userAnswer?.raw ?? "";
  const normalize = (v) => (typeof v === "string" ? v : v?.raw ?? "");
  return (
    <RootFractionInput
      value={raw}
      onChange={(v) => onChange({ raw: normalize(v) })}
      disabled={disabled}
      label="d"
      placeholder="np. 7√2"
    />
  );
}

export function checkAnswer({ data }, userAnswer) {
  const raw = typeof userAnswer === "string" ? userAnswer : userAnswer?.raw ?? "";
  if (!raw) return false;
  const val = parseRoot(raw);
  return Number.isFinite(val) && Math.abs(val - data.dValue) <= DEC_TOL;
}

export const renderAnswer = ({ data }) => <InlineMath math={`d=${data.dLatex}`} />;

export function renderExplanation({ data }) {
  const { a } = data;
  return (
    <div style={{ textAlign: "left", lineHeight: 1.7 }}>
      <strong>Krok 1.</strong> Wzór na przekątną kwadratu: <InlineMath math={'d=a\\sqrt{2}'} />.
      <BlockMath math={`d=${a}\\sqrt{2}`} />
    </div>
  );
}

export function renderUserAnswer(userAnswer) {
  const raw = typeof userAnswer === "string" ? userAnswer : userAnswer?.raw ?? "";
  if (!raw) return <i>(brak odpowiedzi)</i>;
  return <InlineMath math={formatLatexPreview(raw, 'd')} />;
}

export default {
  generateTask,
  renderTask,
  renderInput,
  checkAnswer,
  renderAnswer,
  renderExplanation,
  renderUserAnswer,
};
